import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Table } from "@material-ui/core";
import TableHeader from './TableHeader';
import TableContent from './TableContent';
import { bindActionCreators } from 'redux';
import ActionCreator from './../../../store/actions/index';
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import TableContainerWithHeight from './../../Common/TableContainerWithHeight';
import PaperContainer from "../../Common/PaperContainer";
import t from "../../../languages/pl";

const PendingReports = props => {
    const { pendingReports, height } = props;
    const [idToDelete, setIdToDelete] = useState(null);

    useEffect(() => {
        props.getPendingReports();
    }, []);

    const handleReportDelete = id => setIdToDelete(id);

    const handleReportDeleteConfirmed = () => {
        props.deletePendingReport(idToDelete);
        setIdToDelete(null);
    };

    return (
        <PaperContainer>
            {height &&
                <TableContainerWithHeight height={height}>
                    <Table stickyHeader>
                        <TableHeader />
                        <TableContent
                            reports={pendingReports}
                            onDelete={handleReportDelete}
                        />
                    </Table>
                </TableContainerWithHeight>
            }
            <ConfirmationDialog
                id={idToDelete}
                open={idToDelete !== null}
                onClose={() => setIdToDelete(null)}
                onSubmit={handleReportDeleteConfirmed}
                action={t.deleteReportConfirmation}
            />
        </PaperContainer>
    );
};

const mapStateToProps = (state) => ({
    pendingReports: state.reportReducer.pendingList
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


PendingReports.propTypes = {
    height: PropTypes.number,
    //redux
    pendingReports: PropTypes.array,
    getPendingReportsOnOpen: PropTypes.func,
    deletePendingReport: PropTypes.func,
    getPendingReports: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PendingReports);
